import React, { useEffect, useState } from "react";

const ICONS = {
    success: (
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16.5 6.5L8.25 14.75L3.5 10" />
        </svg>
    ),
    error: (
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="10" cy="10" r="8" />
            <path d="M13 7L7 13M7 7l6 6" />
        </svg>
    ),
    warning: (
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 3L1.5 17h17L10 3z" />
            <path d="M10 8v4M10 14.5v.5" />
        </svg>
    ),
    info: (
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="10" cy="10" r="8" />
            <path d="M10 9v5M10 6.5v.5" />
        </svg>
    ),
};

const Toast = ({ id, type, message, duration, onDismiss }) => {
    const [exiting, setExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setExiting(true);
            setTimeout(() => onDismiss(id), 200);
        }, duration);
        return () => clearTimeout(timer);
    }, [id, duration, onDismiss]);

    const handleDismiss = () => {
        setExiting(true);
        setTimeout(() => onDismiss(id), 200);
    };

    return (
        <div className={`ui-toast ui-toast--${type}${exiting ? " ui-toast--exiting" : ""}`} role="alert">
            <span className="ui-toast__icon">{ICONS[type]}</span>
            <span className="ui-toast__message">{message}</span>
            <button className="ui-toast__dismiss" onClick={handleDismiss} aria-label="Dismiss">×</button>
            <div className="ui-toast__progress" style={{ animationDuration: `${duration}ms` }} />
        </div>
    );
};

export default Toast;
